import React from 'react';

import { Field } from 'formik';

export interface CustomCheckboxProps {
	isChecked: boolean;
	setIsChecked: (e: boolean) => void;
	formikBag: any;
	capture: any;
	className?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
	isChecked,
	setIsChecked,
	formikBag,
	capture,
	className = '',
}) => {
	return (
		<Field
			name="isDisplayed"
		>
			{() => {
				return (
					<div className={`custom-checkbox ${className}`}>
						<input
							type="checkbox"
							checked={isChecked}
							onChange={() => {
								setIsChecked(!isChecked);
								formikBag.setFieldValue('isDisplayed', !isChecked);
							}}
						/>
						<label
							onClick={() => {
								setIsChecked(!isChecked);
								formikBag.setFieldValue('isDisplayed', !isChecked);
							}}
						>
							{capture}
						</label>
					</div>
				);
			}}
		</Field>
	);
};

export default CustomCheckbox;
